import React from "react";
import {
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  LinkedinIcon,
  PinterestIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share";
import poster from "../images/radio.webp";

const twitterHash = [
  "online-radio",
  "live-radio",
  "radiostation",
  "music",
  "radio",
  "musicstation",
  "musicradio",
  "jazz",
  "news",
  "sport",
  "entainment",
  "dance",
  "pop",
  "rock",
  "rap",
  "hiphop",
  "rnb",
  "soul",
  "reggae",
  "country",
  "classical",
  "blues",
  "gospel",
  "funk",
  "disco",
  "techno",
  "house",
  "trance",
  "dubstep",
  "electronic",
  "indie",
  "alternative",
];

const description = `Tune in to our live stream featuring 65,000+ free radio stations from around the World. Every genre, no cost - start listening now! Access anywhere, anytime on any device with a browser - no account needed!!`;

const Share = () => {
  const shareLink = "https://radiobruce.com/";

  return (
    <div className="social-wrapper">
      <FacebookShareButton
        url={shareLink}
        hashtag="#radiobruce"
        aria-label="Center Align"
      >
        <FacebookIcon size={36} round={true} />
      </FacebookShareButton>

      <TwitterShareButton
        url={shareLink}
        hashtag={twitterHash}
        aria-label="Center Align"
      >
        <TwitterIcon size={36} round={true} />
      </TwitterShareButton>

      <WhatsappShareButton
        url={shareLink}
        title="#radiobruce"
        aria-label="Center Align"
      >
        <WhatsappIcon size={36} round={true} />
      </WhatsappShareButton>

      <PinterestShareButton
        url={shareLink}
        media={poster}
        description={description}
        aria-label="Center Align"
      >
        <PinterestIcon size={36} round={true} />
      </PinterestShareButton>

      <LinkedinShareButton
        url={shareLink}
        description={description}
        aria-label="Center Align"
      >
        <LinkedinIcon size={36} round={true} />
      </LinkedinShareButton>
    </div>
  );
};

export default Share;
